exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-radio{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:auto;outline:none}.v-input--radio-group.v-input--radio-group--row .v-radio{margin-right:16px}", ""]);

// exports
